import request from '@/util/request'

const api = {
  // 获取车辆列表
  carsPage: 'cars/carsPage',
  // 添加车辆
  addCar: 'cars/addCar',
  // 更新车辆
  updateCar: 'cars/updateCar',
  // 获取单车辆详情
  carDetail: 'cars/carDetail',
  // 更改车辆状态
  carState: 'cars/carState',
  // 获取车辆待选列表
  carList: 'cars/carList',
  // 获取统计数据
  carStatistic: 'cars/carCost',
  // 获取油卡对应车辆数据
  oilCardList: 'cars/oilCardList',
  // 根据车牌号获取车辆id
  getCarIdByCarNum: 'cars/getCarIdByCarNum',
}

export function carsPage(query) {
  return request({
    url: api.carsPage,
    method: 'get',
    params: query
  })
}

export function addCar(data) {
  return request({
    url: api.addCar,
    method: 'post',
    data
  })
}

export function updateCar(data) {
  return request({
    url: api.updateCar,
    method: 'post',
    data
  })
}

export function carDetail(id) {
  return request({
    url: api.carDetail,
    method: 'get',
    params: { id }
  })
}

export function changeState(id, state) {
  return request({
    url: api.carState,
    method: 'get',
    params: { id, state }
  })
}

export function carList() {
  return request({
    url: api.carList,
    method: 'get'
  })
}

export function carStatistic(query) {
  return request({
    url: api.carStatistic,
    method: 'get',
    params: query
  })
}

export function oilCardList() {
  return request({
    url: api.oilCardList,
    method: 'get',
  })
}

export function getCarIdByCarNum(carNum) {
  return request({
    url: api.getCarIdByCarNum,
    method: 'get',
    params: { carNum }
  })
}
